<template>
  <component :is="$route.meta.layout || 'div'" style="background-color: #F4F5FA;">
    <router-view></router-view>
  </component>
  
  <!-- 전역 스낵바 -->
  <v-snackbar
    v-model="snackbar.show"
    :color="snackbar.color"
    :timeout="snackbar.timeout"
    location="bottom"
    class="global-snackbar"
  >
    <div class="snackbar-content">{{ snackbar.text }}</div>
    <template v-slot:actions>
      <v-btn
        variant="text"
        @click="hideSnackbar"
        icon="mdi-close"
        size="small"
      />
    </template>
  </v-snackbar>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useStore } from 'vuex';

// 다중레이아웃 처리 app.vue
const store = useStore();

// 스낵바 상태 가져오기
const snackbar = computed(() => store.getters.snackbar);

// 스낵바 숨기기 함수
const hideSnackbar = () => {
  store.commit('hideSnackbar');
};
</script>

<style>
.global-snackbar {
  z-index: 10000;
}

.snackbar-content {
  white-space: pre-wrap;
  word-break: break-word;
  max-width: 600px;
}
</style>
